import styled, { css } from 'styled-components';
import { colors, ApInput } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
`;

export const Section = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 7px;
	padding: 2px 24px 0 49px;
`;

export const SectionList = styled.div`
	display: flex;
	flex-direction: column;
`;

export const SectionTitle = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 11px;
	letter-spacing: 0.8px;
	line-height: 13px;
	color: ${colors.grey5};
	text-transform: uppercase;
`;

export const ListIndex = styled.div`
	color: ${colors.grey5};
	font-size: 11px;
	letter-spacing: 0;
	line-height: 13px;
	display: flex;
	margin-right: 12px;
	min-width: 12px;
`;

export const ErrorIconWrapper = styled.div`
	display: flex;
	margin-right: 6px;
	margin-left: -6px;
`;

export const ListValue = styled.div`
	padding: 6px 0;
	display: flex;
	width: 100%;
	align-items: center;
	min-width: 0;
	box-sizing: border-box;
	justify-content: space-between;
`;

export const ListCellWrapper = styled.div`
	margin-right: 12px;

	&:last-child {
		margin-right: 0;
	}
`;

export const ListInputCell = styled(ListCellWrapper)`
	width: 200px;
	margin-right: 32px;
	min-width: 70px;
	position: relative;
	&:nth-child(3) {
		margin-right: 8px;
	}
`;

export const ListStaticCell = styled(ListCellWrapper)`
	font-size: 16px;
	color: ${colors.grey5};
	text-transform: uppercase;
	min-width: 24px;
	position: relative;
`;

export const CurrencyUnit = styled.div`
	font-size: 16px;
	color: ${colors.grey5};
	text-transform: uppercase;
	position: absolute;
	top: 10px;
	right: 8px;
`;

export const ListLabel = styled(ListInputCell)`
	flex-grow: 1;
	min-width: 90px;
	max-width: 450px;
	margin-right: 32px;
`;

export const ListHeader = styled.div`
	font-size: 13px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
`;

export const ListItem = styled.div`
	display: flex;
	align-items: center;
	padding: 0 0 0 16px;
	box-sizing: border-box;
`;

export const IconWrapper = styled.div`
	display: flex;
	cursor: pointer;
	min-width: 24px;
`;

export const StyledButton = styled.span`
	color: ${colors.grey7};
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 19px;
	transition: color 0.2s linear;
	cursor: pointer;
	padding: 10px 24px 0 48px;
	width: fit-content;

	${({ disabled }) =>
		disabled &&
		css`
			color: ${colors.grey3};
			pointer-events: none;
		`};
`;

export const StyledInput = styled(ApInput)`
	${({ hasError }) =>
		hasError &&
		css`
			input {
				border: 2px solid ${colors.red1} !important;
			}
		`};
`;
